import { Component, OnInit, OnDestroy,  } from '@angular/core';
import { LoaderService } from '../../shared/services/api-services/page-loader.service';
import { Subscription } from 'rxjs';
import { NgStyle } from '@angular/common';


@Component({
    selector: 'app-page-loader',
    templateUrl: './page-loader.component.html',
    styleUrls: ['./page-loader.component.scss'],
    imports: [NgStyle]
})
export class PageLoaderComponent implements OnInit, OnDestroy {

  public flagShow = false;
  public textMessage = 'Loading...';
  public loaderShow = false;
  public subscription: Subscription;
  public opacity = .1;

  constructor(private loaderService: LoaderService) { }

  ngOnInit() {
    this.subscription = this.loaderService.loaderState
      .subscribe(res => {
        if (res.onlyBackgroundFlag) {
          this.flagShow = true;
          this.textMessage = '';
          this.loaderShow = !res.onlyBackgroundFlag;
          this.opacity = res.opacity;
        } else {
          this.flagShow = res.show;
          this.textMessage = res.Message;
          this.loaderShow = !res.onlyBackgroundFlag;
          this.opacity = res.opacity;
        }
      });
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}